module.exports = __webpack_public_path__ + "static/media/booking.23d1a35b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/video-thumbnails/booking.png
// module id = 2170
// module chunks = 0